<template>
  <div>
    <z-centralized-toolbar>
      <v-toolbar-items>
        <v-btn id="btn-adicionar" text small color="primary" @click="adicionar">
          <v-icon left>{{ $icon.COMPONENTES }}</v-icon>Adicionar
        </v-btn>

        <v-btn
          text
          id="btn-atualizar"
          @click="refresh"
          :loading="$store.state.loading"
        >
          <v-icon>{{ $icon.REFRESH }}</v-icon>
          <v-tooltip bottom activator="#btn-atualizar"> Atualizar </v-tooltip>
        </v-btn>
      </v-toolbar-items>

      <!-- <v-spacer></v-spacer> -->

      <z-text-field-search
        v-model="busca"
        select
        class="ml-5"
        @keydown.enter="buscar"
        @click:clear="limparBusca"
      ></z-text-field-search>
    </z-centralized-toolbar>

    <v-divider></v-divider>

    <z-scroll-layout :top-position="$v.TOP_POSITION">
      <z-container>
        <z-cabecalho>{{ $store.state.titulo_tela }}</z-cabecalho>

        <v-card>
          <v-data-table
            mobile-breakpoint="0"
            :options.sync="paginacao"
            :server-items-length="total_itens"
            :footer-props="$v.FOOTER_PROPS"
            :headers="headers"
            :items="componentes"
            item-key="id"
          >
            <template v-slot:item.descricao="{ item: componente }">
              <router-link class="text-decoration-none" :to="{ name: 'ComponentesEditar', params: { id: componente.id } }">
                {{ componente.descricao }}
              </router-link>
            </template>

            <template v-slot:item.tempo_estimado="{ value: tempo_estimado }">
              {{ tempo_estimado | horaMinutos }}
            </template>

            <template v-slot:item.opcoes="{ item: componente }">
              <v-btn icon @click="editar(componente)">
                <v-icon>{{ $icon.EDITAR }}</v-icon>
              </v-btn>
              <v-btn icon @click="perguntarExcluir(componente)">
                <v-icon>{{ $icon.EXCLUIR }}</v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </v-card>
      </z-container>
    </z-scroll-layout>

    <z-dialogo-sim-nao
      ref="dialogoRemoverComponente"
      titulo="Remover componente"
      botaoSim="Remover"
      botaoNao="Cancelar"
      :loading="excluindo"
    >
      O componente será removido do sistema.
    </z-dialogo-sim-nao>

  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";

export default {
  name: "ComponentesLista",

  data() {
    return {
      headers: [
        { text: "Código", value: "id", width: "150px" },
        { text: "Descrição", value: "descricao" },
        { text: "Tempo Estimado", value: "tempo_estimado", align: "center" },
        { text: "Pecas", value: "pecas_count", align: "center" },
        {
          text: "Opções",
          value: "opcoes",
          width: "200px",
          align: "center",
          sortable: false,
        },
      ],
      excluindo: false,
      componente_codigo: "",
    };
  },

  created() {
    this.refresh();
  },

  mounted() {
    this.setTitulo("Componentes");
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapActions("componentes", ["listar", "excluir", "abrir"]),

    async refresh() {
      try {
        await this.listar();
      } catch (error) {
        console.log(error);
        this.$eventbus.notificar("Não foi possível listar os componentes.");
      }
    },

    buscar() {
      this.$store.commit("componentes/SET_PAGE", 1);
      this.refresh();
    },

    limparBusca() {
      this.busca = null;
      this.$store.commit("componentes/SET_PAGE", 1);
      this.refresh();
    },

    adicionar() {
      this.$store.commit("componentes/ZERAR");
      this.$router.push({ name: "ComponentesAdicionar" });
    },

    async editar(componente) {
      try {
        await this.abrir(componente.id);
        this.$router.push({ name: "ComponentesEditar", params: { id: componente.id } });
      } catch (error) {
        console.log(error);
        this.$eventbus.notificar("Não foi possível abrir o componente.");
      } finally {
        this.LOADING_OFF();
      }
    },

    perguntarExcluir(componente) {
      this.$refs.dialogoRemoverComponente.abrir().then(async (response) => {
        if (response == true) {
          await this.confirmarExcluir(componente);
          this.$refs.dialogoRemoverComponente.fechar();
        }
      });
    },

    async confirmarExcluir(componente) {
      try {
        this.excluindo = true;
        await this.excluir(componente.id);
        this.$eventbus.notificar("Componente excluído com sucesso!");
      } catch (error) {
        this.$eventbus.notificar("Não foi possível excluir o componente!");
        throw error;
      } finally {
        this.excluindo = false;
      }
    },

    historico(componente) {
      this.componente_codigo = componente.codigo;
      this.$refs.dialogoHistoricoComponente.abrir();
    },
  },

  computed: {
    ...mapState(["loading"]),
    ...mapState("componentes", ["componentes", "componente", "total_itens"]),

    busca: {
      get() {
        return this.$store.state.componentes.busca;
      },
      set(busca) {
        this.$store.commit("componentes/SET_BUSCA", busca);
      },
    },

    paginacao: {
      get() {
        return this.$store.state.componentes.paginacao;
      },
      set(paginacao) {
        this.$store.commit("componentes/UPDATE_PAGINACAO", paginacao);
      },
    },
  },

  watch: {
    paginacao: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
</style>
